
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.314 11.9l3.535-3.536a.998.998 0 00-.316-1.645 1 1 0 00-1.098.231l-3.536 3.535L8.364 6.95A1 1 0 106.95 8.364l3.535 3.535-3.535 3.536a1 1 0 101.414 1.414l3.535-3.535 3.536 3.535a1 1 0 101.414-1.414l-3.535-3.536v.001z","fill":"#9e73c8"}})])
          )
        }
      }
    